<template>
    <m-main-layout>
        <div class="page-content-main">
            <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="auto" class="margin-top" style="width:800px;">
                <el-form-item label="法律声明" prop="law">
                    <editor v-model="formData.law"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "add",
    data() {
        return {
            formData: {
                // service: '',
                law: '',
                // secret:''
            },
            rules: {
                // service:[{required:true}],
                law: [{required: true}],
                // secret:[{required:true}],
            },
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        submitForm(formName) {
            let _this = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(_this.formData);
                    _this.$http.httpPost({
                        url: 'SystemSetting/edit',
                        datas: _this.formData,
                        success: (res) => {
                            if (res === 'ok') {
                                _this.$message.success('修改成功');
                            } else {
                                _this.$message.error('修改失败');
                            }
                            // _this.$message.info(res.msg);
                            // _this.$router.replace({path: '/cate/list'})
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getDetail() {
            let _this = this;

            let _skeys = [];

            for (let k in this.formData) {
                _skeys.push(k);
            }

            _this.$http.httpPost({
                url: 'SystemSetting/getSystem',
                datas: {skey: _skeys},
                success: (res) => {
                    _this.formData = res;
                    // console.log(res);
                    // _this.$message.info(res.msg);
                    // _this.$router.replace({path: '/cate/list'})
                }
            });
        }
    }
}
</script>
